import styled from 'styled-components';
import {mobileMedia} from '../../../globalVariables/GlobalVariables';
import {justifyEnd} from '../../../globalVariables/GlobalFlex';
import {bottom} from '../../popupAfterAdvertise/privateEvent/BottomSection.css';

export const body = styled.div`
    padding: 60px;
    padding-top: 120px;
`;

export const text = styled.div`
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 20px;
    line-height: 1.5;
    width: 60%;
    ${mobileMedia}{
        font-size: 14px;
    }
    white-space: pre-line;
`;

export const buttonContainer = styled(bottom)`
    ${justifyEnd};
`;
